import { HttpClient, HttpParams, HttpUrlEncodingCodec } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { first, of, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AgentPageModel, AgentsReturn } from '../models/agent.model';
import { agentData, agentsData, agentsLocationData } from '../data/agents.data';
import { PropertyReturn } from '../models/property.model';

@Injectable({
  providedIn: 'root'
})
export class AgentsService {

  entityId: any = document.getElementById('aux-env-input');
  agentData: AgentPageModel = agentData;
  agentsData = agentsData;
  agentsLocation = agentsLocationData;

  constructor(private http: HttpClient, private cookieService: CookieService, private translateService: TranslateService) { }

  getCurrentLang() {
    return this.cookieService.check('lang')
      ? this.cookieService.get('lang')
      : this.translateService.currentLang;
  }

  getAgents(filters: any, page: any) {
    const lang = this.getCurrentLang();
    const params = new HttpParams({ encoder: new HttpUrlEncodingCodec() })
      .set('entityId', `${this.entityId.value}`)
      .set('language', lang)
      .set('filters', filters ? JSON.stringify(filters) : JSON.stringify({}))
      .set('page', page);
    return this.http.get<{ agents: AgentsReturn[], total: number }>(`${environment.apiUrl}/agents`, {
      params,
    });
  }

  getAllAgents() {
    // return of(this.agentsLocation);
    const params = new HttpParams({ encoder: new HttpUrlEncodingCodec() })
      .set('entityId', `${this.entityId.value}`)
    return this.http.get<any[]>(`${environment.apiUrl}/agents/all`, {
      params,
    });
  }

  getAgentById(id: any) {
    // return of(this.agentData);
    const lang = this.getCurrentLang();
    const params = new HttpParams({ encoder: new HttpUrlEncodingCodec() })
      .set('entityId', `${this.entityId.value}`)
      .set('language', lang)
    return this.http.get<AgentPageModel>(`${environment.apiUrl}/agents/${id}`, {
      params,
    });
  }


  getAgentWithPropertiesById(id: any, filters: any = null) {
    // return of(this.agentData);
    const lang = this.getCurrentLang();
    const params = new HttpParams({ encoder: new HttpUrlEncodingCodec() })
      .set('entityId', `${this.entityId.value}`)
      .set('filters', filters ? JSON.stringify(filters) : JSON.stringify({}))
      .set('language', lang)
    return this.http.get<AgentPageModel>(`${environment.apiUrl}/agents/v2/${id}`, {
      params,
    });
  }

  getDataToSearch(id: any) {
    const lang = this.cookieService.check('lang')
      ? this.cookieService.get('lang')
      : this.translateService.currentLang;
    const params = new HttpParams({ encoder: new HttpUrlEncodingCodec() })
      .set('entityId', `${this.entityId.value}`)
      .set('language', lang);
    return this.http
      .get<any>(`${environment.apiUrl}/agents/search-data/${id}`, {
        params,
      })
  }

  getAgentProperties(filters: any, page: any, id: any) {
    const lang = this.cookieService.check('lang')
      ? this.cookieService.get('lang')
      : this.translateService.currentLang
    const params = new HttpParams({ encoder: new HttpUrlEncodingCodec() })
      .set('entityId', `${this.entityId.value}`)
      .set('language', lang)
      .set('filters', filters ? JSON.stringify(filters) : JSON.stringify({}))
      .set('page', page);
    return this.http.get<PropertyReturn>(`${environment.apiUrl}/agents/agent-properties/${id}`, {
      params,
    });
    // return of({ properties: this.properties.slice(page, page + 8), total: this.properties.length });
  }
}
